
/* STAHLOR COLLECTION TOP CLEANUP V15 */
/* Text-targeted cleanup only. Does not touch product cards, product images, img src, lazyload, or product-grid-item. */

(function () {
  function isCollectionPage() {
    return /\/collections\//.test(window.location.pathname);
  }

  if (!isCollectionPage()) return;

  var BAD_TEXTS = [
    'WELCOME TO OUR SERVICE CENTRE',
    'STAHLOR COLLECTION',
    'STAHLOR ONLINE STORE',
    'Shop Online',
    'Technical Clarity',
    'Germany-Based Store'
  ];

  function textOf(el) {
    return (el && el.innerText ? el.innerText : '').replace(/\s+/g, ' ').trim();
  }

  function hasBadText(el) {
    var t = textOf(el).toUpperCase();
    return BAD_TEXTS.some(function (needle) {
      return t.indexOf(needle.toUpperCase()) !== -1;
    });
  }

  function containsProductCard(el) {
    if (!el) return false;
    return !!(
      el.querySelector('.stahlor-product-card-v9') ||
      el.querySelector('.stahlor-collection-product-card-v9') ||
      el.querySelector('[class*="product-grid"]') ||
      el.querySelector('[class*="product-item"] form[action*="/cart/add"]')
    );
  }

  function isHeaderChrome(el) {
    if (!el) return false;
    return !!(
      el.closest('header') ||
      el.closest('.header') ||
      el.closest('[class*="header"]') ||
      el.closest('nav')
    );
  }

  function firstProductAnchorTop() {
    var product = document.querySelector('.stahlor-product-card-v9, .stahlor-collection-product-card-v9, form[action*="/cart/add"]');
    if (!product) return 999999;
    return product.getBoundingClientRect().top + window.scrollY;
  }

  function markDuplicateTopBlocks() {
    var limitTop = firstProductAnchorTop();

    var candidates = Array.prototype.slice.call(document.querySelectorAll(
      'section, .container, .row, .breadcrumb-area, .breadcrumb-section, .page-title-area, .page-title-section, .collection-description, .shop-collection-description, .collection-info, [class*="breadcrumb"], [class*="page-title"]'
    ));

    candidates.forEach(function (el) {
      if (!el || el.classList.contains('stahlor-collection-top-duplicate-v15')) return;
      if (isHeaderChrome(el)) return;
      if (containsProductCard(el)) return;

      var rect = el.getBoundingClientRect();
      var top = rect.top + window.scrollY;

      if (top > limitTop) return;
      if (!hasBadText(el)) return;

      el.classList.add('stahlor-collection-top-duplicate-v15');
    });

    /* Fallback: remove direct visual info card before product grid */
    var all = Array.prototype.slice.call(document.body.querySelectorAll('div, section'));
    all.forEach(function (el) {
      if (!el || el.classList.contains('stahlor-collection-top-duplicate-v15')) return;
      if (isHeaderChrome(el)) return;
      if (containsProductCard(el)) return;

      var t = textOf(el);
      if (!t) return;

      var rect = el.getBoundingClientRect();
      var top = rect.top + window.scrollY;
      if (top > limitTop) return;

      var looksLikeCollectionStory =
        /Caravan Accessories & Caravan Equipment/i.test(t) &&
        /Discover practical caravan accessories/i.test(t);

      var looksLikeBenefitCards =
        /Shop Online/i.test(t) &&
        /Technical Clarity/i.test(t) &&
        /Germany-Based Store/i.test(t);

      if (looksLikeCollectionStory || looksLikeBenefitCards) {
        el.classList.add('stahlor-collection-top-duplicate-v15');
      }
    });
  }

  function run() {
    markDuplicateTopBlocks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }

  window.addEventListener('load', run);
})();
